import {get, post} from "./axios";

export function notBlank(str) {
  return str !== null && str !== undefined && str !== ''
}


// 消息列表
export async function listMessage(recordId) {
  return await get(`/plane-risk-record-message/page/1/100`, {
    recordId,
    orderBy: [{"name": "id", "direction": "ASC"}]
  })
}

// 发消息
export async function sendMessage(recordId, body) {
  return await post(`/plane-risk-record/send-message/${recordId}`, body)
}



// WEBPACK FOOTER //
// ./src/api/msg.js